import React from 'react';
import {motion} from 'framer-motion';

import styles from './styles/example-card.module.css';

const cardSpringMotion = {
  hidden: { opacity: 0, y: 100 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 40,
      delay: 0.4
    }
  }
};

const fadeInMotion = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: 'easeIn'
    }
  }
};

export default function ExampleCard({ type, example, title, subTitle, Image, isVisible }) {
  return (
    <div className={styles.wrapper}>
        <motion.p
          initial='hidden'
          animate={isVisible ? 'visible' : 'hidden'}
          variants={fadeInMotion}
        >
          {example}
        </motion.p>
        <motion.div
          className={styles.container}
          data-type={type}
          initial='hidden'
          animate={isVisible ? 'visible' : 'hidden'}
          variants={cardSpringMotion}
        >
            <div className={styles.boxTitle}>
                <p>{title}</p>
                <p>{subTitle}</p>
            </div>
            <div className={styles.boxImage} data-type={type}>
                <Image />
            </div>
        </motion.div>
    </div>
  );
}
